import moment from 'moment';

export const standardDateFormat = (d) => {
  const format = 'YYYY-MM-DD-HH-mm-ss';
  const date = new Date(d);
  return moment(date).format(format);
};
